import './quote-activity.scss';

import { Outlet } from "react-router-dom";

import { FilterQuoteActivityProvider } from "./filter-quote-activity/filter-quote-activity.context";

export function QuoteActivity() {
  return (
    <div id="ShellQuoteActivity" className="quote-activity">
       <FilterQuoteActivityProvider>
        <Outlet />
      </FilterQuoteActivityProvider>
    </div>
  );
}

export default QuoteActivity;
